var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-share-alt",
    "data-name": "Icon awesome-share-alt",
    d: "M55,50a14.935,14.935,0,0,0-9.342,3.265L29.644,43.256a15.086,15.086,0,0,0,0-6.513L45.658,26.735a14.973,14.973,0,1,0-5.3-8.479L24.342,28.265a15,15,0,1,0,0,23.47L40.356,61.744A15,15,0,1,0,55,50Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d3034741b974fec897e660f0be5bd6c2.svg";
export { ForwardRef as ReactComponent };